//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["controlItem"],
  data() {
    return {
      
    };
  },
  computed:{
    cellClass:function(){
      return { 
          'van-cell': true, 
          'van-field':true,
          'van-cell--required':this.controlItem.IsRequired,
      };
    },
  },
  created() {
    
  },

  methods: {

    async doEvent(){

      var $e = this.$cmd.checkEvent(this.controlItem,"OnChange");
      if (!$e) return;

      var $cmd = $e.Cmd;
      if (!$cmd) return;

      var url = $cmd.CommandText;
      await this.$parent.$repostForm(url);
      return;

    },

    onChange(){

      this.doEvent();

    }


  }
};
